import React, { useState, useContext, useEffect } from 'react';
import { useFormikContext } from 'formik';

import { ResponsiveContext, EtapesSaisieContext } from '../../App';
import { Simulation } from '../../types/main';
import { creeClassNamesZoneSaisie } from '../../utils/utils';
import { SaisieContext } from '../formConteneur';
import { MySelect } from '../champsSaisieAffichage/mySelect';
import { MyListeBoutons } from '../champsSaisieAffichage/myListeBoutons';
import { MyTextInput } from '../champsSaisieAffichage/myTextInput';
// import { VoirDetail } from '../boutons/generaux/voirDetail';

export const SaisieTypeOption1: React.FC = () => {
  const { setBoutonSuivant } = useContext(SaisieContext);
  const { dimensions } = useContext(ResponsiveContext);
  const classNamesZoneSaisie = creeClassNamesZoneSaisie(dimensions.largeur, 4);

  useEffect(() => {
    setBoutonSuivant('non');
  }, [])

  return (
    <div
      className={classNamesZoneSaisie.join(' ')}
      // style={styleZoneSaisie}
    >
      <div className="col1">
        <div className="col">
            <h1 className="titre">Option n°1</h1>
          <h2 className="titre">Cette option est-elle <i>latin</i> ou <i>grec</i> ?</h2>
          <div className="group" style={{ display: "flex" }}>
            <MyListeBoutons
              label="type_options1"
              // labelAvecRC={<><u>F</u>ilière</>}
              // toucheRC={['f', 'F']}
              name="latin_ou_grec"
              required
              autoFocus={true}
              boutons={['Oui', 'Non']}
              toucheRC={['o', 'O', 'Enter', 'Escape', 'n', 'N']}
              matchTouchesElement={[0, 0, 0, 1, 1, 1]}
              // boutons={['S', 'ES', 'L', 'STMG']}
              classes={['boutonSize1']}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
